var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{attrs:{"data-cy":"mockAddress"}},[_vm._v(_vm._s(_setup.mockAddress))])])
}
var staticRenderFns = []

export { render, staticRenderFns }